<template>
  <div>
    <filters
      class="md-layout-item md-size-100"
      :use-highway-filter="false"
      :require-to-date="true"
      v-model="dateFilters"
    />

    <udn-table
      :report="report"
      v-if="!loading && !error && report && report.length"
    />

    <transition v-else>
      <loading-content
        :class="error ? 'md-accent' : ''"
        :md-rounded="!loading"
        loading-icon="table_chart"
        loading-label="Cargando reporte..."
        loading-description="Espere un momento."
        empty-icon="table_chart"
        empty-label="Reporte vacio."
        empty-description="Redefina su consulta o intente de nuevo más tarde."
        error-icon="restore"
        error-label="Error cargando reporte"
        error-description="Contacte a un administrador o vuelva a intentar más tarde."
        :loading="loading"
        :error="error"
      />
    </transition>
  </div>
</template>

<script>

import reportsService from '@/services/reports'
import Filters from '@/pages/Macro/Filters'
import UdnTable from './UDNTable'

import moment from 'moment'

export default {

  name: 'UDNReport',

  components: {
    Filters,
    UdnTable,
  },

  data () {
    return {
      loading: false,
      dateFilters: {
        highway: null,
        toDate: moment().startOf("year").format("YYYY-MM-DD"),
        fromDate: moment()
          .subtract(1, "year")
          .startOf("year")
          .format("YYYY-MM-DD")
      },
      report: null,
    }
  },

  methods: {
    fetchReport () {
      const { toDate, fromDate } = this.dateFilters

      this.report = false
      this.error = false
      this.loading = true
      return reportsService.fetchUDNReport({
        toDate: moment(toDate).format("YYYY-MM-DD"),
        fromDate: moment(fromDate).format("YYYY-MM-DD"),
      }).then(report => {
        this.report = report
      }).catch(e => {
        this.error = true
      }).finally(() => {
        this.loading = false
      })
    }
  },

  mounted () {
    this.fetchReport()
  },

  watch: {
    dateFilters: {
      immediate: true,
      handler () {
        this.fetchReport()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Reports/UDNReport/index.vue